export default __webpack_public_path__ + "static/media/quantitas.60d5fcf4.svg";